export const SIDES = {
    LEFT: 'L',
    RIGHT: 'R',
    BOTH: 'B',
}